import styled, { css } from "styled-components";
import getColor from "../../../utils/getColor";
import { getCustomColor } from "../../../utils/getCustomColor";
import space from "../../../utils/space";
import Link from "../../quarks/Link";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";
export var PulsatingButtonContainer = styled(Link).withConfig({
  componentId: "sc-16h3o27-0"
})(["display:inline-block;position:relative;cursor:pointer;"]);
export var PulsatingButton = styled.span.withConfig({
  componentId: "sc-16h3o27-1"
})(function (_ref) {
  var $color = _ref.$color,
    $customColor = _ref.$customColor,
    theme = _ref.theme;
  return css(["display:flex;align-items:center;justify-content:center;padding:", " ", ";border-radius:", ";", " ", ""], space(1.5), space(3), space(2), $color ? css(["background-color:", ";"], getColor(theme, $color)) : null, $customColor ? css(["background:", ";"], getCustomColor($customColor)) : null);
});
export var Text = styled.span.withConfig({
  componentId: "sc-16h3o27-2"
})(function (_ref2) {
  var $color = _ref2.$color,
    $onColor = _ref2.$onColor;
  return css(["display:flex;position:absolute;top:50%;left:50%;align-items:center;justify-content:center;width:100%;height:100%;transform:translate(-50%,-50%);text-decoration:none;", ";"], $onColor || $color ? cssTextAtm({
    typography: "small3",
    color: $color,
    onColor: $onColor
  }) : cssTextAtm({
    typography: "small3",
    color: "customDark"
  }));
});
export var TextPlaceholder = styled.span.withConfig({
  componentId: "sc-16h3o27-3"
})(["opacity:0;"]);